<template>
    <div>
        <div class="modal-content">
            <ul class="nav nav-tabs" id="sigTab" role="tablist">
                <div class="col-4">
                    <li class="nav-item" role="presentation">
                        <a class="nav-link" :class="{ active: ConfigChoose === 0 }"
                           @click="ConfigChoose = 0" id="gera-tab"
                           data-toggle="tab" href="#geral" role="tab" aria-controls="signatory"
                           aria-disabled="true">{{ 'Geral' }}</a>
                    </li>
                </div>
                <div class="col-4">
                    <li class="nav-item" role="presentation">
                        <a class="nav-link" :class="{ active: ConfigChoose === 1 }"
                           @click="ConfigChoose = 1" id="signatory-tab"
                           data-toggle="tab" href="#signatory" role="tab" aria-controls="signatory"
                           aria-disabled="true">{{ 'Configurações Proposta' }}</a>
                    </li>
                </div>
                <div class="col-4">
                    <li class="nav-item" role="presentation">
                        <a class="nav-link" :class="{ active: ConfigChoose === 2 }"
                           @click.stop.prevent="ConfigChoose = 2"
                           id="signatory-disp-tab" data-toggle="tab" href="#signatory-disp" role="tab"
                           aria-controls="localization"
                           aria-disabled="true">{{ 'Configurações Contrato' }} </a>
                    </li>
                </div>
            </ul>
            <div class="modal-body ">
                <div class="row gutters">
                    <template v-if="ConfigChoose === 0">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label class="required">{{ t('CONFIG_CLICK_SIGN.RESPONSIBLE') }}:</label>
                                <Select2 id="responsible" v-model="iten.responsible_id"
                                         :placeholder="iten.responsible_name"
                                         @select="selectResponsible"
                                         v-if="iten.responsible_name" :disabled="isView"
                                         :settings="ajaxPerson"></Select2>
                                <Select2 id="responsible" v-model="iten.responsible_id" placeholder="Selecione"
                                         v-else :disabled="isView" @select="selectResponsible"
                                         :settings="ajaxPerson"></Select2>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label class="required">Token de Acesso:</label>
                                <input type="text" class="form-control" :disabled="isView" v-model="iten.access_token">
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label for="exampleFormControlTextarea1" :class="isEdit? 'required': ''">Mensagem de
                                    Solicitação de Assinatura</label>
                                <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"
                                          v-model="iten.message"
                                          placeholder="Para concluir nossa negociação, por favor leia atentamente e assine o documento que estamos encaminhando."
                                          :disabled="isView"></textarea>
                            </div>
                        </div>
                    </template>
                    <template v-if="ConfigChoose === 1">
                        <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-12">
                            <div class="form-group">
                                <label for="deadline_to_signature"
                                       class="required">{{ t('CONFIG_CLICK_SIGN.DEADLINE_TO_SIGNATURE') }}</label>
                                <input type="number" class="form-control" id="deadline_to_signature"
                                       placeholder="Dias para expiração" max="30"
                                       @keyup="checkMaxNumber"
                                       v-model="iten.deadline_to_signature" :disabled="isView">
                            </div>
                        </div>
                        <div class="col-12 mb-2">
                            <div class="dropdown-divider"></div>
                            <div class="text-center font-weight-bolder" style="color: #0e5e4e">
                                Configurações dos Signatários
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-12" v-for="(configP, key) in signer_configs_proposal"
                             :key="key">
                            <template class="card pl-2 pr-2 pt-2 border pb-0" style="box-shadow: none">
                                <div class="border-bottom text-center"><h6>{{ getNameAssing(configP.signer_type) }}</h6>
                                </div>
                                <div class="d-flex row pt-1">
                                    <div class="col-4" v-if="configP.signer_type === 'seller'">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                   id="proposal_seller_sign"
                                                   v-model="iten.proposal_seller_sign" :disabled="isView">
                                            <label class="custom-control-label"
                                                   for="proposal_seller_sign">
                                                {{t('CONFIG_CLICK_SIGN.SIGN') }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-4" v-if="configP.signer_type === 'witness'">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                   id="proposal_witness_sign"
                                                   v-model="iten.proposal_witness_sign" :disabled="isView">
                                            <label class="custom-control-label"
                                                   for="proposal_witness_sign">
                                                {{t('CONFIG_CLICK_SIGN.SIGN') }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-4" v-if="configP.signer_type === 'manager'">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                   id="proposal_manager_sign"
                                                   v-model="iten.proposal_manager_sign" :disabled="isView">
                                            <label class="custom-control-label"
                                                   for="proposal_manager_sign">
                                                {{t('CONFIG_CLICK_SIGN.SIGN') }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-4" v-if="configP.signer_type === 'sign'">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                   id="proposal_spouse_sign"
                                                   v-model="iten.proposal_spouse_sign" :disabled="isView">
                                            <label class="custom-control-label"
                                                   for="proposal_spouse_sign">
                                                {{t('CONFIG_CLICK_SIGN.SIGN') }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-4" v-if="configP.signer_type === 'broker'">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                   id="realtor_sign"
                                                   v-model="iten.realtor_sign" :disabled="isView">
                                            <label class="custom-control-label"
                                                   for="realtor_sign">
                                                {{t('CONFIG_CLICK_SIGN.SIGN') }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                   :id="`proposal_selfie_enabled_${key}`"
                                                   v-model="configP.selfie_enabled" :disabled="isView || configP.auths === 'icp_brasil'">
                                            <label class="custom-control-label"
                                                   :for="`proposal_selfie_enabled_${key}`">{{
                                                    t('CONFIG_CLICK_SIGN.SELFIE_ENABLED')
                                                }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                   :id="`proposal_handwritten_enabled_${key}`"
                                                   v-model="configP.handwritten_enabled" :disabled="isView || configP.auths === 'icp_brasil'">
                                            <label class="custom-control-label"
                                                   :for="`proposal_handwritten_enabled_${key}`">{{
                                                    t('CONFIG_CLICK_SIGN.HANDWIRITTEN_ENABLED')
                                                }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-4 align-self-center">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                   :id="`proposal_official_document_enabled_${key}`"
                                                   v-model="configP.official_document_enabled" :disabled="isView || configP.auths === 'icp_brasil'">
                                            <label class="custom-control-label"
                                                   :for="`proposal_official_document_enabled_${key}`">{{
                                                    t('CONFIG_CLICK_SIGN.OFFICIAL_DOCUMENT_ENABLED')
                                                }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group" style="min-width: 87px">
                                            <label>{{ t('CONFIG_CLICK_SIGN.AUTHS') }}</label>
                                            <Select2 v-model="configP.auths" placeholder="Selecione"
                                                     v-if="['seller', 'witness'].includes(configP.signer_type)"
                                                     :options="[{id: 'email', text: 'E-mail'},{id: 'icp_brasil', text: 'ICP-Brasil'},...optionZap]"
                                                     :disabled="isView || !['seller', 'witness'].includes(configP.signer_type)"
                                                     @select="changeAuth(key, 'proposal')"
                                                     :settings="{width:'100%'}"></Select2>
                                            <Select2 v-model="configP.auths" placeholder="Selecione"
                                                     v-else
                                                     :options="[{id: 'email', text: 'E-mail'},...optionZap]"
                                                     :disabled="isView"
                                                     @select="changeAuth(key, 'proposal')"
                                                     :settings="{width:'100%'}"></Select2>

                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>
                    <template v-if="ConfigChoose === 2">
                        <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-12">
                            <div class="form-group">
                                <label for="contract_deadline_to_signature"
                                       class="required">{{ t('CONFIG_CLICK_SIGN.DEADLINE_TO_SIGNATURE') }}</label>
                                <input type="number" class="form-control" id="contract_deadline_to_signature"
                                       placeholder="Dias para expiração" max="30"
                                       @keyup="checkMaxNumber"
                                       v-model="iten.contract_deadline_to_signature" :disabled="isView">
                            </div>
                        </div>
                        <div class="col-12 mb-2">
                            <div class="dropdown-divider"></div>
                            <div class="text-center font-weight-bolder" style="color: #0e5e4e">
                                Configurações dos Signatários
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-12" v-for="(configC, key) in signer_configs_contract"
                             :key="key">
                            <template class="card pl-2 pr-2 pt-2 border pb-0" style="box-shadow: none">
                                <div class="border-bottom text-center"><h6>{{ getNameAssing(configC.signer_type) }}</h6>
                                </div>
                                <div class="row d-flex pt-1">
                                    <div class="col-4 " v-if="configC.signer_type === 'seller'">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                   id="contract_seller_sign"
                                                   v-model="iten.contract_seller_sign" :disabled="isView">
                                            <label class="custom-control-label"
                                                   for="contract_seller_sign">
                                                {{t('CONFIG_CLICK_SIGN.SIGN') }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-4 " v-if="configC.signer_type === 'witness'">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                   id="contract_witness_sign"
                                                   v-model="iten.contract_witness_sign" :disabled="isView">
                                            <label class="custom-control-label"
                                                   for="contract_witness_sign">
                                                {{t('CONFIG_CLICK_SIGN.SIGN') }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-4 " v-if="configC.signer_type === 'manager'">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                   id="contract_manager_sign"
                                                   v-model="iten.contract_manager_sign" :disabled="isView">
                                            <label class="custom-control-label"
                                                   for="contract_manager_sign">
                                                {{t('CONFIG_CLICK_SIGN.SIGN') }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-4 " v-if="configC.signer_type === 'sign'">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                   id="contract_spouse_sign"
                                                   v-model="iten.contract_spouse_sign" :disabled="isView">
                                            <label class="custom-control-label"
                                                   for="contract_spouse_sign">
                                                {{t('CONFIG_CLICK_SIGN.SIGN') }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-4 " v-if="configC.signer_type === 'broker'">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                   id="contract_realtor_sign"
                                                   v-model="iten.contract_realtor_sign" :disabled="isView">
                                            <label class="custom-control-label"
                                                   for="contract_realtor_sign">
                                                {{t('CONFIG_CLICK_SIGN.SIGN') }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-4 ">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                   :id="`contract_selfie_enabled_${key}`"
                                                   v-model="configC.selfie_enabled" :disabled="isView || configC.auths === 'icp_brasil'">
                                            <label class="custom-control-label"
                                                   :for="`contract_selfie_enabled_${key}`">{{
                                                    t('CONFIG_CLICK_SIGN.SELFIE_ENABLED')
                                                }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-4 ">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                   :id="`contract_handwritten_enabled_${key}`"
                                                   v-model="configC.handwritten_enabled" :disabled="isView || configC.auths === 'icp_brasil'">
                                            <label class="custom-control-label"
                                                   :for="`contract_handwritten_enabled_${key}`">{{
                                                    t('CONFIG_CLICK_SIGN.HANDWIRITTEN_ENABLED')
                                                }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-4  align-self-center">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                   :id="`contract_official_document_enabled_${key}`"
                                                   v-model="configC.official_document_enabled" :disabled="isView || configC.auths === 'icp_brasil'">
                                            <label class="custom-control-label"
                                                   :for="`contract_official_document_enabled_${key}`">{{
                                                    t('CONFIG_CLICK_SIGN.OFFICIAL_DOCUMENT_ENABLED')
                                                }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-4 ">
                                        <div class="form-group" style="min-width: 87px">
                                            <label>{{ t('CONFIG_CLICK_SIGN.AUTHS') }}</label>
                                            <Select2 v-model="configC.auths" placeholder="Selecione"
                                                     v-if="['seller', 'witness'].includes(configC.signer_type)"
                                                     :options="[{id: 'email', text: 'E-mail'},{id: 'icp_brasil', text: 'ICP-Brasil'}, ...optionZap]"
                                                     :disabled="isView || !['seller', 'witness'].includes(configC.signer_type)"
                                                     @select="changeAuth(key, 'contract')"
                                                     :settings="{width:'100%'}"></Select2>
                                            <Select2 v-model="configC.auths" placeholder="Selecione"
                                                     v-else
                                                     :options="[{id: 'email', text: 'E-mail'}, ...optionZap]"
                                                     :disabled="isView"
                                                     @select="changeAuth(key, 'contract')"
                                                     :settings="{width:'100%'}"></Select2>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
            </div>
            <div class="modal-footer" v-if="!isView">
                <div class="btn btn-primary" @click="createConfig">
                    {{ t('GENERAL.SAVE') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import Select2 from 'vue3-select2-component';
import ConfigClickSign from '../../services/ConfigClickSign';

export default {
    name: "createConfigClickSignComponet",
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    props: {
        itenId: {
            required: false,
        },
        isEdit: {
            type: Boolean,
            default: false,
        },
        isView: {
            type: Boolean,
            default: false,
        }
    },
    mounted() {
        if (this.itenId) {
            this.$store.commit('changeLoading', true);
            ConfigClickSign.view(this.itenId).then((resp) => {
                this.iten = resp.data;
                this.signer_configs_contract = resp.data.signer_configs?.filter(i => i.document_type === 'contract')
                this.signer_configs_proposal = resp.data.signer_configs?.filter(i => i.document_type === 'business_proposals')
                this.$store.commit('changeLoading', false);
            }).catch(() => {
                this.$store.commit('changeLoading', false);
            })
        }
        if (localStorage.getItem('companyId') && ['4d45d80c-829c-4013-80a6-b0d036012b59','ca8ecad3-9e79-4bce-965c-1d7ed59361f0'].includes(localStorage.getItem('companyId'))){
            this.optionZap =[{id:'whatsapp', text: 'Whatsapp'}]
        }
    },
    emits:['created'],
    data() {
        return {
            ConfigChoose: 0,
            iten: {
                deadline_to_signature: 1,
                access_token: '2f66d437-88a2-410b-a077-abbba3d677d7',
                contract_deadline_to_signature: 1,
                contract_realtor_sign: false,
                realtor_sign: false,
            },
            ajaxPerson: {
                width: '100%',
                language: {
                    inputTooShort: function () {
                        return "Por favor, insira ao menos 1 caracteres para pesquisar.";
                    },
                    noResults: function () {
                        return "Nenhum resultado encontrado!";
                    }
                },
                minimumInputLength: 1,
                ajax: {
                    url: `${process.env.VUE_APP_BACK_END}/api/v1/clientes/list`,
                    dataType: "json",
                    headers: {
                        'authorization': `Bearer ${localStorage.getItem('access_token')}`,
                        'company-id': localStorage.getItem('companyId'),
                    },
                    data: params => {
                        return {
                            term: params.term,
                        };
                    },
                    processResults: function (data) {
                        if (!(data.validations)) {
                            data.unshift({id: 0, text: "Nenhum"});
                            return {
                                results: data.map((i) => ({id: i.id, text: i.name}))
                            };
                        } else {
                            return {results: {id: 0, text: "Nenhum"}};
                        }
                    },
                    cache: true
                },
                initSelection: function (element, callback) {
                    callback({id: 1, text: 'initSelection test'});
                },
            },
            signer_configs_contract: [
                {
                    "signer_type": "seller",
                    "document_type": "contract",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "buyer",
                    "document_type": "contract",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "witness",
                    "document_type": "contract",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "manager",
                    "document_type": "contract",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "sign",
                    "document_type": "contract",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "broker",
                    "document_type": "contract",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                }
            ],
            signer_configs_proposal: [
                {
                    "signer_type": "seller",
                    "document_type": "business_proposals",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "buyer",
                    "document_type": "business_proposals",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "witness",
                    "document_type": "business_proposals",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "manager",
                    "document_type": "business_proposals",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "sign",
                    "document_type": "business_proposals",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                },
                {
                    "signer_type": "broker",
                    "document_type": "business_proposals",
                    "auths": "email",
                    "selfie_enabled": true,
                    "handwritten_enabled": true,
                    "official_document_enabled": false,
                    "liveness_enabled": false,
                    "facial_biometrics_enabled": false,
                }
            ],
            optionsSignerType: [
                {id: "seller", text: "Vendedor"},
                {id: "buyer", text: "Comprador"},
                {id: "witness", text: "Testemunhas"},
                {id: "manager", text: "Gerente/Coordenador"},
                {id: "sign", text: "Cônjuge"},
                {id: "broker", text: "Corretor"},
            ],
            optionZap:[],
        }
    },
    components: {
        Select2,
    },
    methods: {
        selectResponsible({text})
        {
            console.log(text)
            this.iten.responsible_name = text;
        },
        createConfig() {
            if (!this.iten.responsible_id) {
                this.toast.error('Preencha todos os campos obrigatorios');
                return;
            }
            this.$store.commit('changeLoading', true);
            if (this.isEdit) {
                if (!this.iten.deadline_to_signature || !this.iten.message?.length) {
                    this.toast.error('Preencha todos os campos obrigatorios');
                    this.$store.commit('changeLoading', false);
                    return;
                }
                ConfigClickSign.edit(this.iten).then(() => {
                    this.$emit('created');
                    this.toast.success('Configuração editada com sucesso!');
                    document.getElementById('closeX')?.click();
                }).catch(err => {
                    this.$store.commit('changeLoading', false);
                    this.errorMsg(err);
                })
                return;
            }
            this.iten.company_id = localStorage.getItem('companyId');
            !this.iten?.deadline_to_signature && delete this.iten.deadline_to_signature;
            !this.iten?.message && delete this.iten.message;
            this.iten.signer_configs = [...this.signer_configs_contract, ...this.signer_configs_proposal];
            ConfigClickSign.create(this.iten).then(() => {
                this.$emit('created');
                this.toast.success('Configuração criada com sucesso!');
                document.getElementById('closeX')?.click();
            }).catch(err => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            })
        },
        getNameAssing(type) {
            return this.optionsSignerType.find((i) => i.id === type)?.text
        },
        changeAuth(key, context) {
            if (context === 'proposal' && this.signer_configs_proposal[key].auths === 'icp_brasil'){
                this.signer_configs_proposal[key].selfie_enabled = false;
                this.signer_configs_proposal[key].handwritten_enabled = false;
                this.signer_configs_proposal[key].official_document_enabled = false;
            }else if (context === 'contract' && this.signer_configs_contract[key].auths === 'icp_brasil'){
                this.signer_configs_contract[key].selfie_enabled = false;
                this.signer_configs_contract[key].handwritten_enabled = false;
                this.signer_configs_contract[key].official_document_enabled = false;
            }
        },
        checkMaxNumber() {
            if (this.iten.deadline_to_signature > 30) {
                this.iten.deadline_to_signature = 30;
            } else if (this.iten.deadline_to_signature <= 0) {
                this.iten.deadline_to_signature = 1;
            }
        }
    }
}
</script>

<style scoped>

</style>